import { IAffiliateCodeState } from './types';
import { PAGE_LIST_INIT_STATE } from './constants';

export default (): IAffiliateCodeState => ({
  codesListData: PAGE_LIST_INIT_STATE,
  codeBatchesListData: PAGE_LIST_INIT_STATE,
  codeDetail: null
});
